<template>
  <tr-loading
    v-if="isLoading"
    classes="center-h-and-v"
  />
  <infraction-details
    v-if="!isLoading"
    :infraction-data="infraction"
  />

  <template v-if="!isLoading && showRefunds">
    <hr :class="$style.line">

    <infraction-refunds
      :infraction-data="infraction"
    />
  </template>

  <hr
    v-if="isAnalysisFormVisible"
    :class="$style.line"
  >

  <infraction-analysis-form
    v-if="isAnalysisFormVisible"
    :infraction-data="infraction"
    :is-read-only="isReadOnly"
    @show-analysis-form="showAnalysisForm"
    @back="onBack"
    @analysis-submitted="$emit('analysis-submitted')"
  />

  <tr-footer-buttons-container
    v-if="!isAnalysisFormVisible"
    class="inline-block"
  >
    <bg-button
      class="pull-left"
      variant="outline"
      @click="onBack"
    >
      Voltar
    </bg-button>
    <bg-button
      v-if="infraction.analysis_status === 'pending' && !infraction.contested_at"
      class="pull-right"
      size="md"
      @click="showAnalysisForm(true)"
    >
      Responder infração
    </bg-button>
  </tr-footer-buttons-container>
</template>

<script>
import InfractionDetails from '@/apps/contestations/infractions/presentational/InfractionDetails.vue';
import InfractionAnalysisForm from '@/apps/contestations/infractions/presentational/InfractionAnalysisForm.vue';
import InfractionRefunds from '@/apps/contestations/infractions/presentational/InfractionRefunds.vue';
import { getInfraction } from '@/apps/contestations/infractions/services/infractions';
import { BgButton } from '@transfeeradev/bridge';

export default {
  name: 'infraction-details-container',
  components: {
    InfractionDetails,
    InfractionAnalysisForm,
    InfractionRefunds,
    BgButton
  },
  emits: ['back', 'analysis-submitted'],
  data() {
    return {
      isLoading: true,
      isAnalysisFormVisible: false,
      infraction: {},
      readOnlyAnalysisStatus: ['accepted', 'rejected']
    };
  },
  computed: {
    isReadOnly() {
      return this.readOnlyAnalysisStatus.includes(this.infraction.analysis_status);
    },
    showRefunds() {
      return this.infraction?.id && this.infraction?.analysis_status !== 'pending';
    }
  },
  created() {
    this.fetchInfraction();
  },
  methods: {
    async fetchInfraction() {
      try {
        this.isLoading = true;
        this.infraction = await getInfraction(this.$route.params.id);
      } catch (error) {
        this.$toaster.error('Não foi possível carregar os detalhes da infração.');
      } finally {
        this.isLoading = false;
        if (this.isReadOnly) {
          this.isAnalysisFormVisible = true;
        }
      }
    },
    onBack() {
      this.$emit('back');
    },
    showAnalysisForm(boolean) {
      this.isAnalysisFormVisible = boolean;
    }
  }
};
</script>

<style scoped module>
.line {
  border: 1px solid var(--bg-grey-light);
  opacity: 0.7;
  width: 100%;
  margin: var(--bg-spacing-md) 0;
}
</style>
